module.exports = __webpack_public_path__ + "static/img/coin-off.e0c309d1.png";